/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */

import * as actions from '@tunnel-enums/index';
import {CombinesObjectModels} from '@tunnel-models/index';
import * as actionsTypesFromStore from '@tunnel-store/index';
import {Reducer} from 'redux';

/**
 * @function SectionSwitchSegmentedReducer
 * @param { any } sate: L'etat de l'application
 * @param {  actionsTypesFromStore.TypeSectionSwitchSegmentedAction } action:
 *     action de l'application
 * @return { Reducer }
 */
export const SectionSwitchSegmentedReducer: Reducer<CombinesObjectModels<any>> =
    (state: any = {

     }, action: actionsTypesFromStore.TypeSectionSwitchSegmentedAction) => {
      switch (action.type) {
        case actions.SectionSwitchSegmentedActionTypes
            .SECTIONSWITCHSEGMENTED_INPROGRESS:

          return {
            loading: true, ...state
          }

          break;
        case actions.SectionSwitchSegmentedActionTypes
            .SECTIONSWITCHSEGMENTED_FAIL:

          return {
            error: action.payload.error, loading: false,
          }

          break;

        case actions.SectionSwitchSegmentedActionTypes
            .SECTIONSWITCHSEGMENTED_SUCCESS:

          return {
            data: action.payload.data, loading: false,
          }

          break;

        default:
          return state
          break;
      }
    }


// WEBPACK FOOTER //
// ./src/apps/tunnel/store/reducers/actions/section/switchsegmented/index.ts